import { render, staticRenderFns } from "./iconPopover.vue?vue&type=template&id=28ecb82c&scoped=true"
import script from "./iconPopover.vue?vue&type=script&lang=js"
export * from "./iconPopover.vue?vue&type=script&lang=js"
import style0 from "./iconPopover.vue?vue&type=style&index=0&id=28ecb82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecb82c",
  null
  
)

export default component.exports